var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature mt-h"},[_c('feature-tittle'),_c('feature-content',{attrs:{"featureList":_vm.featureList}}),_c('back-top')],1)}
var staticRenderFns = []

export { render, staticRenderFns }